module.exports = __webpack_public_path__ + "static/media/polaroid-6.c40d2c03.png";